import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { SpacerVertical, TitleSecondary } from 'mage-deps/@klarna/bubble-ui'
import { useHelpContext } from './hooks'
import { Message } from 'mage-i18n'
import { useEducationAnalytics, useEducationFeature } from 'education-tools'
import FeedbackSelector from './FeedbackSelector'
import SupportButton from './SupportButton'

Feedback.propTypes = {
  articleId: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired
}

export default function Feedback({ articleId, articleTitle }) {
  const [wasHelpful, setWasHelpful] = useState(null)
  const { navigation } = useHelpContext()
  const isSupportCenterActive = useEducationFeature('meg.merchant-support-center')
  const isUnhelpful = wasHelpful === 'no'

  const track = useEducationAnalytics({
    category: 'uhqm/feedback',
    action: 'click',
    referenceType: 'article',
    referenceId: articleId
  })

  useEffect(() => {
    setWasHelpful(null)
  }, [articleId])

  const showSupportButton = isSupportCenterActive && isUnhelpful

  return (
    <div>
      <TitleSecondary id="uhqm-feedback-title">
        <Message path="hqm.feedback.title" fallback="Was this helpful?" />
      </TitleSecondary>
      <FeedbackSelector value={wasHelpful} onSelect={handleSelect} />
      <SpacerVertical small />
      {showSupportButton && (
        <SupportButton analyticsCategory="uhqm/support-button/article" scrollIntoView />
      )}
    </div>
  )

  function handleSelect(value) {
    setWasHelpful(value)

    track({ label: value })

    if (isUnhelpful && !isSupportCenterActive) {
      navigation.push('moreHelp', { articleId, articleTitle })
    }
  }
}
